import Logo from '../assets/png/Gangasystems.png'
export const headerData = {
    name: 'GANGA SYSTEMS',
    title: "HARDWARE NETWORK ENGINEER",
    desciption:"In a world where technology weaves the very fabric of our existence, there lies a professional whose heart beats in sync with the rhythm of data pulsing through networks and the hum of hardware coming to life. This individual is not just a hardware and network engineer.",
     image: Logo,
    // image: 'https://raw.githubusercontent.com/PhantomScript/asset-container/main/developer-portfolio/landingImg.png',
    // resumePdf: resume
}
